import { useEffect, useState } from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import useAuth from '@hooks/use-auth'
import { Loader, Center } from '@mantine/core'

export default function AuthLayout() {
  const { isAuthenticated } = useAuth()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Add a small delay to prevent blinking during auth check
    const timer = setTimeout(() => {
      setLoading(false)
    }, 100)

    return () => clearTimeout(timer)
  }, [])

  // Helper function to get user email from localStorage
  const getUserEmail = () => {
    if (typeof window !== 'undefined') {
      const authData = localStorage.getItem('authData');
      if (authData) {
        try {
          const parsed = JSON.parse(authData);
          return parsed.email?.toLowerCase() || '';
        } catch {
          return '';
        }
      }
    }
    return '';
  }

  if (loading) {
    return (
      <Center style={{ height: '100vh' }}>
        <Loader size="lg" />
      </Center>
    )
  }

  if (isAuthenticated) {
    const userEmail = getUserEmail();
    // Redirect Samuel to dashboard, others to doc-pabean
    if (userEmail.includes('samuel')) {
      return <Navigate to="/dashboard" replace />
    }
    return <Navigate to="/doc-pabean" replace />
  }

  return <Outlet />
}